webpackJsonp([8],{

/***/ 121:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_normalize_css__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_normalize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_normalize_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "app",
  methods: {
    isFrontPage: function isFrontPage() {
      return this.$route.path === "/";
    }
  }
});

/***/ }),

/***/ 122:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 123:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(31);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var _STADTKATALOG_CONFIG = {"siteName":"StadtKatalog","geoFenceName":null,"mapZoom":12,"mapCenter":[48.208417,16.372472],"clusterOptions":{"maxClusterRadius":50}},
    siteName = _STADTKATALOG_CONFIG.siteName;


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "sk-overview",
  data: function data() {
    return {
      loading: true
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])(["overview"]), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(["hasNextOverviewPage", "hasPrevOverviewPage"]), {
    rageStart: function rageStart() {
      return this.overview.page * this.overview.size + 1;
    },
    rangeEnd: function rangeEnd() {
      return Math.min(this.overview.total, this.overview.page * this.overview.size + this.overview.size);
    },
    currentPage: function currentPage() {
      return this.overview.page + 1;
    },
    validPage: function validPage() {
      return this.overview.page >= 0 && this.rageStart <= this.overview.total;
    },
    maxPage: function maxPage() {
      return Math.ceil(this.overview.total / this.overview.size);
    },
    currentPageClass: function currentPageClass() {
      if (this.overview.page === 0) {
        return "first-page";
      } else if (!this.hasNextOverviewPage) {
        return "last-page";
      }

      return "normal-page";
    }
  }),
  watch: {
    $route: function $route() {
      var _this = this;

      this.setPage();
      this.loading = true;
      this.$store.dispatch("updateOverview").then(function () {
        _this.loading = false;
      });
    }
  },
  methods: {
    setPage: function setPage() {
      if (this.$route.query.page) {
        var pageCandidate = parseInt(this.$route.query.page, 10);
        if (!isNaN(pageCandidate) && pageCandidate > 0) {
          this.overview.page = pageCandidate - 1;
        } else {
          this.$router.replace({ name: "sk-overview" });
        }
      } else {
        this.overview.page = 0;
      }
    }
  },
  created: function created() {
    var _this2 = this;

    document.title = "Überblick - " + siteName;

    this.setPage();
    this.loading = true;
    this.$store.dispatch("updateOverview").then(function () {
      _this2.loading = false;
    });
  }
});

/***/ }),

/***/ 132:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_StadtKatalogSearch__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_StadtKatalogPromotions__ = __webpack_require__(135);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var _STADTKATALOG_CONFIG = {"siteName":"StadtKatalog","geoFenceName":null,"mapZoom":12,"mapCenter":[48.208417,16.372472],"clusterOptions":{"maxClusterRadius":50}},
    siteName = _STADTKATALOG_CONFIG.siteName;




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "seestadtbot-search",
  components: {
    "sk-search": __WEBPACK_IMPORTED_MODULE_2__components_StadtKatalogSearch__["a" /* default */],
    "sk-promotions": __WEBPACK_IMPORTED_MODULE_3__components_StadtKatalogPromotions__["a" /* default */]
  },
  data: function data() {
    return {
      demoQueries: ["Arzt", "Apotheke", "Restaurant", "Bäckerei", "Buchhandlung", "Spar", "Coworking"]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])(["geoFenceName", "totalHits", "promotionEntries"]), {
    showSuggestions: function showSuggestions() {
      return this.totalHits <= 0;
    },
    showPromotions: function showPromotions() {
      return window.__PRERENDER__ === undefined && this.promotionEntries.length > 0;
    },
    proposalUrl: function proposalUrl() {
      return "https://app.stadtkatalog.org/stk/proposeEntry" + (this.geoFenceName !== null ? "?geoFenceName=" + this.geoFenceName : "");
    }
  }),
  methods: {
    setQuery: function setQuery(query) {
      this.$store.commit("setQuery", query);
      this.$refs.search.queryStadtKatalog();
      this.$refs.search.focusSearchField();
    }
  },
  created: function created() {
    document.title = "Seestadt-Verzeichnis - " + siteName;
    this.$store.commit("resetQueryStates");
    this.$store.dispatch("updatePromotionEntries");
  }
});

/***/ }),

/***/ 133:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StadtKatalogSearch_vue__ = __webpack_require__(134);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a8c626c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StadtKatalogSearch_vue__ = __webpack_require__(298);
function injectStyle (ssrContext) {
  __webpack_require__(296)
}
var normalizeComponent = __webpack_require__(21)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5a8c626c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StadtKatalogSearch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a8c626c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StadtKatalogSearch_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 134:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_debounce__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(31);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var MIN_QUERY_LENGTH = 3;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "sk-search",
  data: function data() {
    return {
      useAutocompleteStyle: true,
      error: ""
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    query: {
      get: function get() {
        return this.$store.state.query;
      },
      set: function set(value) {
        this.$store.commit("setQuery", value);
      }
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapState */])(["totalHits", "hits", "querySize", "queryFrom", "geoFenceName", "loading"]), Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(["totalPages", "currentPage", "hasPrevPage", "hasNextPage"]), {
    hasQuery: function hasQuery() {
      return this.query && this.query.length >= MIN_QUERY_LENGTH;
    },
    proposeEntryUrl: function proposeEntryUrl() {
      return "https://app.stadtkatalog.org/stk/proposeEntry" + (this.geoFenceName !== null ? "?geoFenceName=" + this.geoFenceName : "");
    }
  }),
  methods: {
    queryStadtKatalog: function queryStadtKatalog() {
      var _this = this;

      this.$store.dispatch("updateHits").then(function () {
        // track a site search
        if (window._paq && _this.totalHits >= 0) {
          window._paq.push(["trackSiteSearch", _this.query, false, _this.totalHits]);
        }
      }).catch(function (e) {
        if (e.message === "Failed to fetch") {
          _this.error = "Verbindung zum StadtKatalog konnte nicht hergestellt werden.";
        } else {
          _this.error = "StadtKatalog konnte nicht abgefragt werden.";
        }
      });
    },
    debouncedQueryStadtKatalog: __WEBPACK_IMPORTED_MODULE_1_lodash_debounce___default()(function () {
      if (this.query.length >= MIN_QUERY_LENGTH) {
        // eager setLoading to prevent flashes in the autocomplete
        this.$store.commit("setLoading", true);
        this.setListStyle(true);
        this.queryStadtKatalog();
      } else if (this.query === "") {
        this.$store.commit("resetQueryStates");
      }
    }, 450),
    focusSearchField: function focusSearchField() {
      this.$refs.searchField.focus();
    },
    clearSearch: function clearSearch() {
      this.query = "";
      this.$refs.searchField.focus();
    },
    setListStyle: function setListStyle(useAutocomplete) {
      this.useAutocompleteStyle = useAutocomplete === true;
      var url = new URL(document.location);
      if (this.useAutocompleteStyle) {
        url.searchParams.delete("q");
        window.history.replaceState({}, document.title, url);
      } else {
        url.searchParams.set("q", encodeURIComponent(this.query));
        window.history.replaceState({}, document.title, url);
      }
    },
    nextPage: function nextPage() {
      if (this.queryFrom + this.querySize < this.totalHits) {
        this.$store.commit("setQueryFrom", this.queryFrom + this.querySize);
        this.queryStadtKatalog();
      }
    },
    prevPage: function prevPage() {
      if (this.queryFrom > 0) {
        this.$store.commit("setQueryFrom", Math.max(this.queryFrom - this.querySize, 0));
        this.queryStadtKatalog();
      }
    }
  },
  created: function created() {
    this.$store.commit("resetQueryStates");
    var params = new URL(document.location).searchParams;
    var query = decodeURIComponent(params.get("q") || "");
    if (query.length >= MIN_QUERY_LENGTH) {
      this.query = decodeURIComponent(query);
      this.setListStyle(false);
      this.queryStadtKatalog();
    }
    this.$watch("query", function () {
      this.debouncedQueryStadtKatalog();
    });
  },
  mounted: function mounted() {
    this.focusSearchField();
  }
});

/***/ }),

/***/ 135:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StadtKatalogPromotions_vue__ = __webpack_require__(136);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3bbfa61a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StadtKatalogPromotions_vue__ = __webpack_require__(302);
function injectStyle (ssrContext) {
  __webpack_require__(299)
}
var normalizeComponent = __webpack_require__(21)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StadtKatalogPromotions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3bbfa61a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StadtKatalogPromotions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 136:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EntryPromotions__ = __webpack_require__(152);

//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "sk-promotions",
  components: {
    EntryPromotions: __WEBPACK_IMPORTED_MODULE_3__EntryPromotions__["a" /* default */]
  },
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])(["promotionDays", "promotionEntries"]), {
    sortedEntryPromotions: function sortedEntryPromotions() {
      if (!this.promotionEntries) {
        return [];
      }

      var startLowerBound = __WEBPACK_IMPORTED_MODULE_2_moment__().startOf("day");
      var endUpperBound = __WEBPACK_IMPORTED_MODULE_2_moment__().add(this.promotionDays, "days").endOf("day");

      return this.promotionEntries.map(function (entry) {
        return {
          id: entry.id,
          data: entry.data,
          promotions: entry.data.promotions.map(function (promotion) {
            promotion.start = __WEBPACK_IMPORTED_MODULE_2_moment__(promotion.start, "YYYY-MM-DDTHH:mm:ss.SSSZZ");
            promotion.end = __WEBPACK_IMPORTED_MODULE_2_moment__(promotion.end, "YYYY-MM-DDTHH:mm:ss.SSSZZ");

            return promotion;
          }).filter(function (promotion) {
            return promotion.start.isSameOrAfter(startLowerBound) && promotion.start.isSameOrBefore(endUpperBound) || promotion.end.isSameOrAfter(startLowerBound) && promotion.end.isSameOrBefore(endUpperBound);
          }).sort(function (a, b) {
            return a.valueOf() - b.valueOf();
          })
        };
      }).filter(function (entry) {
        return entry.promotions.length > 0;
      }).sort(function (entryA, entryB) {
        return entryA.promotions[0].start.valueOf() - entryB.promotions[0].start.valueOf();
      }).slice(0, 5);
    }
  })
});

/***/ }),

/***/ 137:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "sk-entry-promotions",
  props: {
    promotions: {
      type: Array,
      required: true
    },
    headlineLevel: {
      type: Number,
      default: 3
    },
    defaultDaysIntoFuture: {
      type: Number,
      default: 7
    }
  },
  data: function data() {
    return {
      now: __WEBPACK_IMPORTED_MODULE_0_moment__(),
      showAllPromotions: false
    };
  },

  computed: {
    hasFuturePromotions: function hasFuturePromotions() {
      return this.promotions.some(this.isTooFarInFuture);
    }
  },
  methods: {
    showHref: function showHref(promotion) {
      return promotion.href && /^https?:\/\/.+$/.test(promotion.href);
    },
    readableURL: function readableURL(promotion) {
      try {
        return new URL(promotion.href).hostname;
      } catch (e) {
        return promotion.href;
      }
    },
    showDateDiff: function showDateDiff(promotion) {
      return this.now.isSameOrAfter(promotion.start) && promotion.end.diff(this.now, "days") <= 3;
    },
    dateDiff: function dateDiff(promotion) {
      return promotion.end.diff(this.now, "days");
    },
    isSameYear: function isSameYear(promotion) {
      return promotion.start.year() === promotion.end.year();
    },
    isSameMonth: function isSameMonth(promotion) {
      return promotion.start.isSame(promotion.end, "month");
    },
    isSameDay: function isSameDay(promotion) {
      return promotion.start.isSame(promotion.end, "day");
    },
    isTooFarInFuture: function isTooFarInFuture(promotion) {
      return promotion.start.isAfter(__WEBPACK_IMPORTED_MODULE_0_moment__().add(this.defaultDaysIntoFuture, "day"), "day");
    }
  }
});

/***/ }),

/***/ 138:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_StadtKatalogSearch__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_StadtKatalogPromotions__ = __webpack_require__(135);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "frontpage-stadtkatalog",
  components: {
    "sk-search": __WEBPACK_IMPORTED_MODULE_2__components_StadtKatalogSearch__["a" /* default */],
    "sk-promotions": __WEBPACK_IMPORTED_MODULE_3__components_StadtKatalogPromotions__["a" /* default */]
  },
  data: function data() {
    return {
      demoQueries: ["Arzt", "Apotheke", "Restaurant", "Bäckerei", "Buchhandlung", "Spar", "Coworking"]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])(["geoFenceName", "totalHits", "promotionDays", "promotionEntries"]), {
    showSuggestions: function showSuggestions() {
      return this.totalHits <= 0;
    },
    showPromotions: function showPromotions() {
      return window.__PRERENDER__ === undefined && this.promotionEntries.length > 0;
    },
    proposalUrl: function proposalUrl() {
      return "https://app.stadtkatalog.org/stk/proposeEntry" + (this.geoFenceName !== null ? "?geoFenceName=" + this.geoFenceName : "");
    }
  }),
  methods: {
    setQuery: function setQuery(query) {
      // only commit, the watcher in the search component automatically triggers the query
      this.$store.commit("setQuery", query);
      this.$refs.search.focusSearchField();
    }
  },
  created: function created() {
    document.title = {"siteName":"StadtKatalog","geoFenceName":null,"mapZoom":12,"mapCenter":[48.208417,16.372472],"clusterOptions":{"maxClusterRadius":50}}.siteName;
    this.$store.dispatch("updatePromotionEntries");
  }
});

/***/ }),

/***/ 152:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EntryPromotions_vue__ = __webpack_require__(137);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53da35ff_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EntryPromotions_vue__ = __webpack_require__(301);
function injectStyle (ssrContext) {
  __webpack_require__(300)
}
var normalizeComponent = __webpack_require__(21)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-53da35ff"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EntryPromotions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53da35ff_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EntryPromotions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 158:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_typed_array_buffer__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_typed_array_buffer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_typed_array_buffer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_typed_data_view__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_typed_data_view___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_typed_data_view__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_typed_int8_array__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_typed_int8_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_typed_int8_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_typed_uint8_array__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_typed_uint8_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_typed_uint8_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_typed_uint8_clamped_array__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_typed_uint8_clamped_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_typed_uint8_clamped_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_typed_int16_array__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_typed_int16_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_typed_int16_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_typed_uint16_array__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_typed_uint16_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_typed_uint16_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_typed_int32_array__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_typed_int32_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_typed_int32_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_typed_uint32_array__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_typed_uint32_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_typed_uint32_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_typed_float32_array__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_typed_float32_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_typed_float32_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_typed_float64_array__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_typed_float64_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_typed_float64_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_map__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_set__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_weak_map__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_weak_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_weak_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_weak_set__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_weak_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_weak_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_reflect_apply__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_reflect_apply___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_reflect_apply__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_reflect_construct__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_reflect_construct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_reflect_construct__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_reflect_define_property__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_reflect_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_reflect_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_reflect_delete_property__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_reflect_delete_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_reflect_delete_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_reflect_get__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_reflect_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_reflect_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_reflect_get_own_property_descriptor__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_reflect_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_reflect_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_reflect_get_prototype_of__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_reflect_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_reflect_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_reflect_has__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_reflect_has___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_reflect_has__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_core_js_modules_es6_reflect_is_extensible__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_core_js_modules_es6_reflect_is_extensible___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_core_js_modules_es6_reflect_is_extensible__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_core_js_modules_es6_reflect_own_keys__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_core_js_modules_es6_reflect_own_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_core_js_modules_es6_reflect_own_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_core_js_modules_es6_reflect_prevent_extensions__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_core_js_modules_es6_reflect_prevent_extensions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_core_js_modules_es6_reflect_prevent_extensions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_core_js_modules_es6_reflect_set__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_core_js_modules_es6_reflect_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_core_js_modules_es6_reflect_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_core_js_modules_es6_reflect_set_prototype_of__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_core_js_modules_es6_reflect_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_core_js_modules_es6_reflect_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_core_js_modules_es6_promise__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_core_js_modules_es6_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_core_js_modules_es6_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_core_js_modules_es6_symbol__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_core_js_modules_es6_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_core_js_modules_es6_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_core_js_modules_es6_object_freeze__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_core_js_modules_es6_object_freeze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_core_js_modules_es6_object_freeze__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_core_js_modules_es6_object_seal__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_core_js_modules_es6_object_seal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_core_js_modules_es6_object_seal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_core_js_modules_es6_object_prevent_extensions__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_core_js_modules_es6_object_prevent_extensions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_core_js_modules_es6_object_prevent_extensions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_core_js_modules_es6_object_is_frozen__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_core_js_modules_es6_object_is_frozen___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33_core_js_modules_es6_object_is_frozen__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_core_js_modules_es6_object_is_sealed__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_core_js_modules_es6_object_is_sealed___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34_core_js_modules_es6_object_is_sealed__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_core_js_modules_es6_object_is_extensible__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_core_js_modules_es6_object_is_extensible___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35_core_js_modules_es6_object_is_extensible__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_core_js_modules_es6_object_get_own_property_descriptor__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_core_js_modules_es6_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36_core_js_modules_es6_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_core_js_modules_es6_object_get_prototype_of__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_core_js_modules_es6_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37_core_js_modules_es6_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_core_js_modules_es6_object_keys__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_core_js_modules_es6_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38_core_js_modules_es6_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_core_js_modules_es6_object_get_own_property_names__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_core_js_modules_es6_object_get_own_property_names___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39_core_js_modules_es6_object_get_own_property_names__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_core_js_modules_es6_object_assign__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_core_js_modules_es6_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40_core_js_modules_es6_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_core_js_modules_es6_object_is__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_core_js_modules_es6_object_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41_core_js_modules_es6_object_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_core_js_modules_es6_object_set_prototype_of__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_core_js_modules_es6_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42_core_js_modules_es6_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_core_js_modules_es6_function_name__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_core_js_modules_es6_function_name___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43_core_js_modules_es6_function_name__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_core_js_modules_es6_string_raw__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_core_js_modules_es6_string_raw___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44_core_js_modules_es6_string_raw__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_core_js_modules_es6_string_from_code_point__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_core_js_modules_es6_string_from_code_point___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45_core_js_modules_es6_string_from_code_point__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46_core_js_modules_es6_string_code_point_at__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46_core_js_modules_es6_string_code_point_at___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46_core_js_modules_es6_string_code_point_at__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47_core_js_modules_es6_string_repeat__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47_core_js_modules_es6_string_repeat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_47_core_js_modules_es6_string_repeat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48_core_js_modules_es6_string_starts_with__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48_core_js_modules_es6_string_starts_with___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_48_core_js_modules_es6_string_starts_with__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49_core_js_modules_es6_string_ends_with__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49_core_js_modules_es6_string_ends_with___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_49_core_js_modules_es6_string_ends_with__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50_core_js_modules_es6_string_includes__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50_core_js_modules_es6_string_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_50_core_js_modules_es6_string_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51_core_js_modules_es6_regexp_flags__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51_core_js_modules_es6_regexp_flags___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_51_core_js_modules_es6_regexp_flags__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52_core_js_modules_es6_regexp_match__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52_core_js_modules_es6_regexp_match___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_52_core_js_modules_es6_regexp_match__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53_core_js_modules_es6_regexp_replace__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53_core_js_modules_es6_regexp_replace___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_53_core_js_modules_es6_regexp_replace__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54_core_js_modules_es6_regexp_split__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54_core_js_modules_es6_regexp_split___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_54_core_js_modules_es6_regexp_split__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55_core_js_modules_es6_regexp_search__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55_core_js_modules_es6_regexp_search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_55_core_js_modules_es6_regexp_search__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56_core_js_modules_es6_array_from__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56_core_js_modules_es6_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_56_core_js_modules_es6_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57_core_js_modules_es6_array_of__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57_core_js_modules_es6_array_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_57_core_js_modules_es6_array_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58_core_js_modules_es6_array_copy_within__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58_core_js_modules_es6_array_copy_within___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_58_core_js_modules_es6_array_copy_within__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59_core_js_modules_es6_array_find__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59_core_js_modules_es6_array_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_59_core_js_modules_es6_array_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60_core_js_modules_es6_array_find_index__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60_core_js_modules_es6_array_find_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_60_core_js_modules_es6_array_find_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61_core_js_modules_es6_array_fill__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61_core_js_modules_es6_array_fill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_61_core_js_modules_es6_array_fill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62_core_js_modules_es6_array_iterator__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62_core_js_modules_es6_array_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_62_core_js_modules_es6_array_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63_core_js_modules_es6_number_is_finite__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63_core_js_modules_es6_number_is_finite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_63_core_js_modules_es6_number_is_finite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64_core_js_modules_es6_number_is_integer__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64_core_js_modules_es6_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_64_core_js_modules_es6_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65_core_js_modules_es6_number_is_safe_integer__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65_core_js_modules_es6_number_is_safe_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_65_core_js_modules_es6_number_is_safe_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66_core_js_modules_es6_number_is_nan__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66_core_js_modules_es6_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_66_core_js_modules_es6_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67_core_js_modules_es6_number_epsilon__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67_core_js_modules_es6_number_epsilon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_67_core_js_modules_es6_number_epsilon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68_core_js_modules_es6_number_min_safe_integer__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68_core_js_modules_es6_number_min_safe_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_68_core_js_modules_es6_number_min_safe_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69_core_js_modules_es6_number_max_safe_integer__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69_core_js_modules_es6_number_max_safe_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_69_core_js_modules_es6_number_max_safe_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70_core_js_modules_es6_math_acosh__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70_core_js_modules_es6_math_acosh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_70_core_js_modules_es6_math_acosh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71_core_js_modules_es6_math_asinh__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71_core_js_modules_es6_math_asinh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_71_core_js_modules_es6_math_asinh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72_core_js_modules_es6_math_atanh__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72_core_js_modules_es6_math_atanh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_72_core_js_modules_es6_math_atanh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73_core_js_modules_es6_math_cbrt__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73_core_js_modules_es6_math_cbrt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_73_core_js_modules_es6_math_cbrt__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74_core_js_modules_es6_math_clz32__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74_core_js_modules_es6_math_clz32___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_74_core_js_modules_es6_math_clz32__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75_core_js_modules_es6_math_cosh__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75_core_js_modules_es6_math_cosh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_75_core_js_modules_es6_math_cosh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76_core_js_modules_es6_math_expm1__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76_core_js_modules_es6_math_expm1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_76_core_js_modules_es6_math_expm1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77_core_js_modules_es6_math_fround__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77_core_js_modules_es6_math_fround___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_77_core_js_modules_es6_math_fround__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78_core_js_modules_es6_math_hypot__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78_core_js_modules_es6_math_hypot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_78_core_js_modules_es6_math_hypot__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79_core_js_modules_es6_math_imul__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79_core_js_modules_es6_math_imul___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_79_core_js_modules_es6_math_imul__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80_core_js_modules_es6_math_log1p__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80_core_js_modules_es6_math_log1p___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_80_core_js_modules_es6_math_log1p__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81_core_js_modules_es6_math_log10__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81_core_js_modules_es6_math_log10___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_81_core_js_modules_es6_math_log10__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82_core_js_modules_es6_math_log2__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82_core_js_modules_es6_math_log2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_82_core_js_modules_es6_math_log2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83_core_js_modules_es6_math_sign__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83_core_js_modules_es6_math_sign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_83_core_js_modules_es6_math_sign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84_core_js_modules_es6_math_sinh__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84_core_js_modules_es6_math_sinh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_84_core_js_modules_es6_math_sinh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85_core_js_modules_es6_math_tanh__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85_core_js_modules_es6_math_tanh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_85_core_js_modules_es6_math_tanh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86_core_js_modules_es6_math_trunc__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86_core_js_modules_es6_math_trunc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_86_core_js_modules_es6_math_trunc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87_core_js_modules_es7_array_includes__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87_core_js_modules_es7_array_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_87_core_js_modules_es7_array_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88_core_js_modules_es7_object_values__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88_core_js_modules_es7_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_88_core_js_modules_es7_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89_core_js_modules_es7_object_entries__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89_core_js_modules_es7_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_89_core_js_modules_es7_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90_core_js_modules_es7_object_get_own_property_descriptors__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90_core_js_modules_es7_object_get_own_property_descriptors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_90_core_js_modules_es7_object_get_own_property_descriptors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91_core_js_modules_es7_string_pad_start__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91_core_js_modules_es7_string_pad_start___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_91_core_js_modules_es7_string_pad_start__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92_core_js_modules_es7_string_pad_end__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92_core_js_modules_es7_string_pad_end___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_92_core_js_modules_es7_string_pad_end__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93_core_js_modules_web_timers__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93_core_js_modules_web_timers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_93_core_js_modules_web_timers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94_core_js_modules_web_immediate__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94_core_js_modules_web_immediate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_94_core_js_modules_web_immediate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95_core_js_modules_web_dom_iterable__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95_core_js_modules_web_dom_iterable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_95_core_js_modules_web_dom_iterable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96_regenerator_runtime_runtime__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96_regenerator_runtime_runtime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_96_regenerator_runtime_runtime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97_vue__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98__AppStadtKatalog__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99__router__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100_leaflet__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100_leaflet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_100_leaflet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101_vue2_leaflet__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101_vue2_leaflet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_101_vue2_leaflet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102_vue2_leaflet_markercluster__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102_vue2_leaflet_markercluster___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_102_vue2_leaflet_markercluster__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_103__store__ = __webpack_require__(334);


































































































/// step 1: prepare everything for tracking

var _paq = window._paq = _paq || [];
_paq.push(["setCookieDomain", "*.stadtkatalog.org"]);
_paq.push(["enableHeartBeatTimer",  true ? 7 : 45]);

(function () {
  var u = "https://stats.pnp-appserver.xyz/";
  _paq.push(['setTrackerUrl', u + 'matomo.php']);
  _paq.push(['setSiteId',  true ? "5" : "3"]);
  var d = document,
      g = d.createElement('script'),
      s = d.getElementsByTagName('script')[0];
  g.type = 'text/javascript';g.async = true;g.defer = true;g.src = u + 'matomo.js';s.parentNode.insertBefore(g, s);
})();

// step 2: initialize application




__WEBPACK_IMPORTED_MODULE_97_vue__["a" /* default */].config.productionTip = false;

// maps + webpack fix for leaflet

delete __WEBPACK_IMPORTED_MODULE_100_leaflet___default.a.Icon.Default.prototype._getIconUrl;
__WEBPACK_IMPORTED_MODULE_100_leaflet___default.a.Icon.Default.mergeOptions({
  iconRetinaUrl: __webpack_require__(330),
  iconUrl: __webpack_require__(273),
  shadowUrl: __webpack_require__(331)
});



__WEBPACK_IMPORTED_MODULE_97_vue__["a" /* default */].component("v-map", __WEBPACK_IMPORTED_MODULE_101_vue2_leaflet___default.a.Map);
__WEBPACK_IMPORTED_MODULE_97_vue__["a" /* default */].component("v-tilelayer", __WEBPACK_IMPORTED_MODULE_101_vue2_leaflet___default.a.TileLayer);
__WEBPACK_IMPORTED_MODULE_97_vue__["a" /* default */].component("v-marker", __WEBPACK_IMPORTED_MODULE_101_vue2_leaflet___default.a.Marker);
__WEBPACK_IMPORTED_MODULE_97_vue__["a" /* default */].component("v-popup", __WEBPACK_IMPORTED_MODULE_101_vue2_leaflet___default.a.Popup);
__WEBPACK_IMPORTED_MODULE_97_vue__["a" /* default */].component("v-geo-json", __WEBPACK_IMPORTED_MODULE_101_vue2_leaflet___default.a.GeoJSON);
__WEBPACK_IMPORTED_MODULE_97_vue__["a" /* default */].component("v-marker-cluster", __WEBPACK_IMPORTED_MODULE_102_vue2_leaflet_markercluster___default.a);


__WEBPACK_IMPORTED_MODULE_103__store__["a" /* default */].state.promotionDays = 2;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_97_vue__["a" /* default */]({
  el: "#app",
  router: __WEBPACK_IMPORTED_MODULE_99__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_103__store__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_98__AppStadtKatalog__["a" /* default */]);
  }
});

/***/ }),

/***/ 271:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppStadtKatalog_vue__ = __webpack_require__(121);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46684ada_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppStadtKatalog_vue__ = __webpack_require__(277);
function injectStyle (ssrContext) {
  __webpack_require__(272)
  __webpack_require__(275)
}
var normalizeComponent = __webpack_require__(21)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-46684ada"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppStadtKatalog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46684ada_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppStadtKatalog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 272:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 273:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAApCAYAAADAk4LOAAAFgUlEQVR4Aa1XA5BjWRTN2oW17d3YaZtr2962HUzbDNpjszW24mRt28p47v7zq/bXZtrp/lWnXr337j3nPCe85NcypgSFdugCpW5YoDAMRaIMqRi6aKq5E3YqDQO3qAwjVWrD8Ncq/RBpykd8oZUb/kaJutow8r1aP9II0WmLKLIsJyv1w/kqw9Ch2MYdB++12Onxee/QMwvf4/Dk/Lfp/i4nxTXtOoQ4pW5Aj7wpici1A9erdAN2OH64x8OSP9j3Ft3b7aWkTg/Fm91siTra0f9on5sQr9INejH6CUUUpavjFNq1B+Oadhxmnfa8RfEmN8VNAsQhPqF55xHkMzz3jSmChWU6f7/XZKNH+9+hBLOHYozuKQPxyMPUKkrX/K0uWnfFaJGS1QPRtZsOPtr3NsW0uyh6NNCOkU3Yz+bXbT3I8G3xE5EXLXtCXbbqwCO9zPQYPRTZ5vIDXD7U+w7rFDEoUUf7ibHIR4y6bLVPXrz8JVZEql13trxwue/uDivd3fkWRbS6/IA2bID4uk0UpF1N8qLlbBlXs4Ee7HLTfV1j54APvODnSfOWBqtKVvjgLKzF5YdEk5ewRkGlK0i33Eofffc7HT56jD7/6U+qH3Cx7SBLNntH5YIPvODnyfIXZYRVDPqgHtLs5ABHD3YzLuespb7t79FY34DjMwrVrcTuwlT55YMPvOBnRrJ4VXTdNnYug5ucHLBjEpt30701A3Ts+HEa73u6dT3FNWwflY86eMHPk+Yu+i6pzUpRrW7SNDg5JHR4KapmM5Wv2E8Tfcb1HoqqHMHU+uWDD7zg54mz5/2BSnizi9T1Dg4QQXLToGNCkb6tb1NU+QAlGr1++eADrzhn/u8Q2YZhQVlZ5+CAOtqfbhmaUCS1ezNFVm2imDbPmPng5wmz+gwh+oHDce0eUtQ6OGDIyR0uUhUsoO3vfDmmgOezH0mZN59x7MBi++WDL1g/eEiU3avlidO671bkLfwbw5XV2P8Pzo0ydy4t2/0eu33xYSOMOD8hTf4CrBtGMSoXfPLchX+J0ruSePw3LZeK0juPJbYzrhkH0io7B3k164hiGvawhOKMLkrQLyVpZg8rHFW7E2uHOL888IBPlNZ1FPzstSJM694fWr6RwpvcJK60+0HCILTBzZLFNdtAzJaohze60T8qBzyh5ZuOg5e7uwQppofEmf2++DYvmySqGBuKaicF1blQjhuHdvCIMvp8whTTfZzI7RldpwtSzL+F1+wkdZ2TBOW2gIF88PBTzD/gpeREAMEbxnJcaJHNHrpzji0gQCS6hdkEeYt9DF/2qPcEC8RM28Hwmr3sdNyht00byAut2k3gufWNtgtOEOFGUwcXWNDbdNbpgBGxEvKkOQsxivJx33iow0Vw5S6SVTrpVq11ysA2Rp7gTfPfktc6zhtXBBC+adRLshf6sG2RfHPZ5EAc4sVZ83yCN00Fk/4kggu40ZTvIEm5g24qtU4KjBrx/BTTH8ifVASAG7gKrnWxJDcU7x8X6Ecczhm3o6YicvsLXWfh3Ch1W0k8x0nXF+0fFxgt4phz8QvypiwCCFKMqXCnqXExjq10beH+UUA7+nG6mdG/Pu0f3LgFcGrl2s0kNNjpmoJ9o4B29CMO8dMT4Q5ox8uitF6fqsrJOr8qnwNbRzv6hSnG5wP+64C7h9lp30hKNtKdWjtdkbuPA19nJ7Tz3zR/ibgARbhb4AlhavcBebmTHcFl2fvYEnW0ox9xMxKBS8btJ+KiEbq9zA4RthQXDhPa0T9TEe69gWupwc6uBUphquXgf+/FrIjweHQS4/pduMe5ERUMHUd9xv8ZR98CxkS4F2n3EUrUZ10EYNw7BWm9x1GiPssi3GgiGRDKWRYZfXlON+dfNbM+GgIwYdwAAAAASUVORK5CYII="

/***/ }),

/***/ 275:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 276:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 277:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('header',{staticClass:"content-container"},[_c('div',{staticClass:"content-box"},[_c('div',{staticClass:"header-content"},[(!_vm.isFrontPage())?_c('router-link',{attrs:{"to":"/"}},[_c('h1',[_c('img',{attrs:{"src":__webpack_require__(122),"alt":"StadtKatalog","title":""}})])]):_c('div',[_c('h1',[_c('img',{attrs:{"src":__webpack_require__(122),"alt":"StadtKatalog","title":""}})])])],1)])]),_vm._v(" "),_c('main',{staticClass:"content-container"},[_c('div',{staticClass:"content-box"},[_c('router-view')],1)]),_vm._v(" "),_c('footer',[_c('router-link',{attrs:{"to":"/ueber"}},[_vm._v("Impressum")]),_vm._v(" | "),_c('router-link',{attrs:{"to":"/datenschutz"}},[_vm._v("Datenschutz")]),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"https://stadtkatalog.org"}},[_vm._v("(CC BY 4.0) StadtKatalog.org")]),_c('br'),_c('br'),_vm._v("\n    Datenquellen (CC BY 4.0):"),_c('br'),_c('a',{attrs:{"href":"https://data.wien.gv.at"}},[_vm._v("Stadt Wien")]),_vm._v(" | Grundkarte von "),_c('a',{attrs:{"href":"https://basemap.at"}},[_vm._v("Basemap.at")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 278:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_StadtKatalogOverview__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_seestadtbot_SeestadtBotSearch__ = __webpack_require__(294);



// sync loading



var _STADTKATALOG_CONFIG = {"siteName":"StadtKatalog","geoFenceName":null,"mapZoom":12,"mapCenter":[48.208417,16.372472],"clusterOptions":{"maxClusterRadius":50}},
    siteName = _STADTKATALOG_CONFIG.siteName;

var isSeestadtBot = siteName === "Seestadt.bot";

// async loading / code splitting
var Entry = function Entry() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 343));
};
var StadtKatalogMap = function StadtKatalogMap() {
  return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 344));
};
var Privacy = function Privacy() {
  return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 345));
};
var SeestadtBotPrivacy = function SeestadtBotPrivacy() {
  return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 346));
};
var About = function About() {
  return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 347));
};
var SeestadtBotHilfe = function SeestadtBotHilfe() {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 348));
};
var SeestadtBotAbout = function SeestadtBotAbout() {
  return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 349));
};

// CommonJS syntax for dynamic import
var FrontPage = __webpack_require__(304).default;

/**
 * Piwik / Matomo tracking
 */
function trackPageView(url, referrerUrl) {
  if (window._paq) {
    // wait for nextTick + add 250ms delay to
    // give some time to refresh document.title before tracking
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].nextTick(function () {
      setTimeout(function () {
        window._paq.push(['setCustomUrl', url], ['setDocumentTitle', document.title]);
        if (referrerUrl) {
          window._paq.push(['setReferrerUrl', referrerUrl]);
        }
        window._paq.push(['trackPageView'], ['enableLinkTracking']);
      }, 250);
    });
  }
}

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: "history",
  routes: [{
    path: "/",
    name: "home",
    component: FrontPage
  }, {
    path: (isSeestadtBot ? "/stadtkatalog" : "") + "/eintrag/:id",
    name: "entry",
    component: Entry
  }, {
    path: (isSeestadtBot ? "/stadtkatalog" : "") + "/ueberblick",
    name: "sk-overview",
    component: __WEBPACK_IMPORTED_MODULE_2__components_StadtKatalogOverview__["a" /* default */]
  }, {
    path: (isSeestadtBot ? "/stadtkatalog" : "") + "/karte",
    name: "sk-map",
    component: StadtKatalogMap
  }, {
    path: "/ueber",
    name: "about",
    component: isSeestadtBot ? SeestadtBotAbout : About
  }, {
    path: "/datenschutz",
    name: "privacy",
    component: isSeestadtBot ? SeestadtBotPrivacy : Privacy
  }],
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});

// Special routes for the Seestadt.bot domain
if (siteName === "Seestadt.bot") {
  router.addRoutes([{
    path: "/stadtkatalog",
    name: "search",
    component: __WEBPACK_IMPORTED_MODULE_3__components_seestadtbot_SeestadtBotSearch__["a" /* default */]
  }, {
    path: "/hilfe",
    name: "help",
    component: SeestadtBotHilfe
  }]);
}

var firstRun = true;

router.afterEach(function (to, from) {
  trackPageView(to.fullPath, !firstRun ? document.location + (from.fullPath !== "/" ? from.fullPath : "") : document.referrer);
  firstRun = false;
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 280:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StadtKatalogOverview_vue__ = __webpack_require__(123);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_743b503d_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StadtKatalogOverview_vue__ = __webpack_require__(293);
function injectStyle (ssrContext) {
  __webpack_require__(281)
}
var normalizeComponent = __webpack_require__(21)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-743b503d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StadtKatalogOverview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_743b503d_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StadtKatalogOverview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 281:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 293:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-wrapper"},[_c('h1',[_vm._v("Überblick")]),_vm._v(" "),(_vm.loading)?_c('div',[_vm._v("\n    Lade ...\n  ")]):_c('div',[_c('ol',{staticClass:"entry-list",attrs:{"start":_vm.rageStart}},_vm._l((_vm.overview.entries),function(entry){return _c('li',{key:entry._id},[_c('router-link',{attrs:{"to":{ name: 'entry', params: { id: entry._id }}}},[_c('h2',[_vm._v(_vm._s(entry.name))])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(entry.description))])],1)}),0),_vm._v(" "),(_vm.validPage)?_c('div',{staticClass:"pager"},[(_vm.hasPrevOverviewPage)?_c('router-link',{staticClass:"button",attrs:{"to":{ name: 'sk-overview', query: { page: _vm.currentPage - 1 }}}},[_vm._v("\n        Zurück\n      ")]):_vm._e(),_vm._v(" "),_c('p',{class:_vm.currentPageClass},[_vm._v("Seite "+_vm._s(_vm.currentPage)+" von "+_vm._s(_vm.maxPage)),_c('br'),_vm._v("Insgesamt "+_vm._s(_vm.overview.total)+" Einträge")]),_vm._v(" "),(_vm.hasNextOverviewPage)?_c('router-link',{staticClass:"button",attrs:{"to":{ name: 'sk-overview', query: { page: _vm.currentPage + 1 }}}},[_vm._v("\n        Weiter\n      ")]):_vm._e()],1):_c('p',[_vm._v("\n      Ungültige Seite!\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 294:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SeestadtBotSearch_vue__ = __webpack_require__(132);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b000306c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SeestadtBotSearch_vue__ = __webpack_require__(303);
function injectStyle (ssrContext) {
  __webpack_require__(295)
}
var normalizeComponent = __webpack_require__(21)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SeestadtBotSearch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b000306c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SeestadtBotSearch_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 295:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 296:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 298:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search-wrapper"},[_c('div',{staticClass:"search-bar"},[_c('label',{staticClass:"sr-only",attrs:{"for":"query"}},[_vm._v("Search")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.query),expression:"query"}],ref:"searchField",staticClass:"search-field",attrs:{"id":"query","type":"text","maxlength":"500","autocomplete":"off","title":"Suche","spellcheck":"false"},domProps:{"value":(_vm.query)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.setListStyle(false)},"input":function($event){if($event.target.composing){ return; }_vm.query=$event.target.value}}}),_vm._v(" "),(_vm.hasQuery && !_vm.loading)?_c('span',{staticClass:"search-status-indicator"},[_c('button',{attrs:{"aria-controls":"query"},on:{"click":_vm.clearSearch}},[_vm._v("×"),_c('span',{staticClass:"sr-only"},[_vm._v("Suche abbrechen")])])]):(_vm.loading)?_c('span',{staticClass:"search-status-indicator"},[_c('svg',{attrs:{"viewBox":"0 0 100 100","preserveAspectRatio":"xMidYMid"}},[_c('circle',{attrs:{"cx":"50","cy":"50","r":"25","stroke-width":"10","stroke":"#bababa","stroke-dasharray":"39.269908169872416 39.269908169872416","fill":"none","stroke-linecap":"round"}},[_c('animateTransform',{attrs:{"attributeName":"transform","type":"rotate","repeatCount":"indefinite","dur":"1.333333333333333s","keyTimes":"0;1","values":"0 50 50;360 50 50"}})],1)])]):_vm._e()]),_vm._v(" "),_c('div',{class:{ 'result-wrapper': true, 'result-wrapper-autocomplete': _vm.useAutocompleteStyle, 'result-wrapper-list': !_vm.useAutocompleteStyle  }},[(!_vm.loading && _vm.totalHits > 0)?_c('div',[(!_vm.useAutocompleteStyle)?_c('div',{staticClass:"result-list-header"},[_vm._v("\n            Es\n            "),(_vm.totalHits > 1)?[_vm._v("wurden")]:[_vm._v("wurde")],_vm._v("\n            "+_vm._s(_vm.totalHits)+"\n            "),(_vm.totalHits > 1)?[_vm._v("Einträge")]:[_vm._v("Eintrag")],_vm._v("\n            gefunden:\n          ")],2):_vm._e(),_vm._v(" "),(_vm.hits.length > 0)?_c('ol',{staticClass:"results"},[_vm._l((_vm.hits),function(hit){return _c('li',{key:hit.id},[_c('router-link',{attrs:{"to":{ name: 'entry', params: { id: hit.id }}}},[_c('h3',[_vm._v(_vm._s(hit.data.name))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(hit.data.description))])])],1)}),_vm._v(" "),(_vm.useAutocompleteStyle)?_c('li',{staticClass:"list-footer"},[_vm._v("\n              Es\n              "),(_vm.totalHits > 1)?[_vm._v("wurden")]:[_vm._v("wurde")],_vm._v("\n              "+_vm._s(_vm.totalHits)+"\n              "),(_vm.totalHits > 1)?[_vm._v("Einträge")]:[_vm._v("Eintrag")],_vm._v("\n              gefunden.\n            ")],2):_vm._e()],2):_vm._e(),_vm._v(" "),(!_vm.useAutocompleteStyle)?_c('div',{staticClass:"page-navigation"},[(_vm.hasPrevPage)?_c('button',{staticClass:"button",on:{"click":function($event){return _vm.prevPage()}}},[_vm._v("Vorherige Seite")]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"page-navigation-current-page"},[_vm._v("Seite "+_vm._s(_vm.currentPage)+" von "+_vm._s(_vm.totalPages))]),_vm._v(" "),(_vm.hasNextPage)?_c('button',{staticClass:"button",on:{"click":function($event){return _vm.nextPage()}}},[_vm._v("Nächste Seite")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.totalHits == 0 && !_vm.loading)?_c('div',{staticClass:"no-results"},[_c('p',[_vm._v("Es wurden keine Einträge für „"+_vm._s(_vm.query)+"“ gefunden.")]),_vm._v(" "),_c('p',{staticClass:"suggest-stadtkatalog-entry"},[_c('a',{staticClass:"button",attrs:{"href":_vm.proposeEntryUrl}},[_vm._v("\n                Neuen Eintrag vorschlagen\n              ")])])]):_vm._e()]):_vm._e()]),_vm._v(" "),(_vm.error !== '')?_c('div',{staticClass:"error"},[_c('h1',[_vm._v("Fehler aufgetreten")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.error))])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 299:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 300:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 301:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ol',{class:{ 'show-all-promotions': _vm.showAllPromotions, 'entry-promotions': true }},_vm._l((_vm.promotions),function(promotion){return _c('li',{key:promotion.start,class:_vm.isTooFarInFuture(promotion) ? 'too-far' : ''},[(_vm.headlineLevel === 1)?_c('h1',[_vm._v(_vm._s(promotion.title))]):_vm._e(),_vm._v(" "),(_vm.headlineLevel === 2)?_c('h2',[_vm._v(_vm._s(promotion.title))]):_vm._e(),_vm._v(" "),(_vm.headlineLevel === 3)?_c('h3',[_vm._v(_vm._s(promotion.title))]):_vm._e(),_vm._v(" "),(_vm.headlineLevel === 4)?_c('h4',[_vm._v(_vm._s(promotion.title))]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"date-range"},[(_vm.showDateDiff(promotion))?[_c('span',{staticClass:"date-diff"},[(_vm.dateDiff(promotion) > 0)?[(_vm.dateDiff(promotion) > 1)?[_vm._v("\n                Noch "+_vm._s(_vm.dateDiff(promotion))+" Tage\n              ")]:[_vm._v("\n                Vorletzer Tag\n              ")]]:[_vm._v("\n              Letzter Tag\n            ")]],2),_vm._v("\n           – \n        ")]:_vm._e(),_vm._v(" "),(_vm.isSameYear(promotion))?[(_vm.isSameDay(promotion))?[_vm._v("\n            "+_vm._s(promotion.start.format("D. MMMM YYYY"))+"\n          ")]:(_vm.isSameMonth(promotion))?[_vm._v("\n            "+_vm._s(promotion.start.format("D."))+" bis "+_vm._s(promotion.end.format("D. MMMM YYYY"))+"\n          ")]:[_vm._v("\n            "+_vm._s(promotion.start.format("D. MMMM"))+" bis "+_vm._s(promotion.end.format("D. MMMM YYYY"))+"\n          ")]]:[_vm._v("\n          "+_vm._s(promotion.start.format("D. MMMM YYYY"))+" bis "+_vm._s(promotion.end.format("D. MMMM YYYY"))+"\n        ")]],2),_vm._v(" "),_c('p',{staticClass:"promotion-text"},[_vm._v(_vm._s(promotion.text))]),_vm._v(" "),(_vm.showHref(promotion))?_c('p',{staticClass:"promo-link ion-android-open"},[_c('a',{attrs:{"href":promotion.href},domProps:{"textContent":_vm._s(_vm.readableURL(promotion))}})]):_vm._e()])}),0),_vm._v(" "),(_vm.hasFuturePromotions)?_c('div',{staticClass:"show-future-promotions"},[_c('button',{staticClass:"button",on:{"click":function($event){_vm.showAllPromotions = !_vm.showAllPromotions}}},[(_vm.showAllPromotions)?_c('span',[_vm._v("Weniger ")]):_c('span',[_vm._v("Weitere ")]),_vm._v("\n      Angebote anzeigen …\n    ")])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 302:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.sortedEntryPromotions.length > 0)?_c('ol',{staticClass:"promotions-wrapper"},_vm._l((_vm.sortedEntryPromotions),function(entry){return _c('li',{key:entry.id},[_c('h3',[_c('router-link',{attrs:{"to":{ name: 'entry', params: { id: entry.id } }}},[_vm._v(_vm._s(entry.data.name))])],1),_vm._v(" "),_c('entry-promotions',{attrs:{"promotions":entry.promotions,"headline-level":4}})],1)}),0):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 303:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"seestadtbot-search"},[_vm._m(0),_vm._v(" "),_c('sk-search',{ref:"search"}),_vm._v(" "),(_vm.showSuggestions)?[_c('section',{staticClass:"query-suggestions"},[_c('h2',[_vm._v("Populäre Suchbegriffe")]),_vm._v(" "),_c('ul',{staticClass:"suggestion-list"},_vm._l((_vm.demoQueries),function(query){return _c('li',{key:query},[_c('span',{staticClass:"button",on:{"click":function($event){return _vm.setQuery(query)}}},[_vm._v(_vm._s(query))])])}),0)]),_vm._v(" "),(_vm.showPromotions)?_c('section',{staticClass:"promotions"},[_c('h2',[_vm._v("Aktuelle Angebote und Aktionen")]),_vm._v(" "),_c('sk-promotions')],1):_vm._e(),_vm._v(" "),_c('section',[_c('h2',[_vm._v("Die Seestadt erkunden")]),_vm._v(" "),_c('ul',{staticClass:"suggestion-list"},[_c('li',{staticClass:"map-link"},[_c('router-link',{staticClass:"button",attrs:{"to":{ name: 'sk-map'}}},[_vm._v("Alles auf einer Karte")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"button",attrs:{"to":{ name: 'sk-map', query: { tag: '3420 :: einkaufen + genießen' } }}},[_vm._v("Einkaufen + Genießen")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"button",attrs:{"to":{ name: 'sk-map', query: { tag: '3420 :: gesundheit + freizeit' } }}},[_vm._v("Gesundheit + Freizeit")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"button",attrs:{"to":{ name: 'sk-map', query: { tag: '3420 :: bildung + kultur' } }}},[_vm._v("Bildung + Kultur")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"button",attrs:{"to":{ name: 'sk-map', query: { tag: '3420 :: wohnen + arbeiten' } }}},[_vm._v("Wohnen + Arbeiten")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"button",attrs:{"to":{ name: 'sk-map', query: { tag: '3420 :: nachbarschaft' } }}},[_vm._v("Nachbarschaft")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"button",attrs:{"to":{ name: 'sk-map', query: { tag: '3420 :: mobilität' } }}},[_vm._v("Mobilität")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"button",attrs:{"to":{ name: 'sk-overview' }}},[_vm._v("Alles in einer Liste")])],1)])]),_vm._v(" "),_c('section',{staticClass:"something-missing"},[_c('p',[_vm._v("\n        Fehlt dein Unternehmen oder Geschäft? Hast du einen Verein oder bietest ein Service in der Seestadt an?\n        Seestadt.bot basiert auf dem StadtKatalog, wo du dich einfach einträgst und damit auch hier erscheinst.\n      ")]),_vm._v(" "),_c('p',{staticClass:"suggest-stadtkatalog-entry"},[_c('a',{staticClass:"button",attrs:{"href":_vm.proposalUrl}},[_vm._v("\n          Eintrag vorschlagen\n        ")])])])]:_vm._e()],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',[_c('span',{staticClass:"hidden-mobile"},[_vm._v("Seestadt-")]),_vm._v("Verzeichnis")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 304:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FrontPageStadtKatalog_vue__ = __webpack_require__(138);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c3ff36e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FrontPageStadtKatalog_vue__ = __webpack_require__(306);
function injectStyle (ssrContext) {
  __webpack_require__(305)
}
var normalizeComponent = __webpack_require__(21)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1c3ff36e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FrontPageStadtKatalog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c3ff36e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FrontPageStadtKatalog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 305:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 306:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('sk-search',{ref:"search"}),_vm._v(" "),(_vm.showSuggestions)?[_c('section',{staticClass:"query-suggestions"},[_c('h2',[_vm._v("Populäre Suchbegriffe")]),_vm._v(" "),_c('ul',{staticClass:"suggestion-list"},_vm._l((_vm.demoQueries),function(query){return _c('li',{key:query},[_c('span',{staticClass:"button",on:{"click":function($event){return _vm.setQuery(query)}}},[_vm._v(_vm._s(query))])])}),0)]),_vm._v(" "),(_vm.showPromotions)?_c('section',{staticClass:"promotions"},[_c('h2',[_vm._v("Aktuelle Angebote und Aktionen")]),_vm._v(" "),_c('sk-promotions')],1):_vm._e(),_vm._v(" "),_c('section',[_c('h2',[_vm._v("Den StadtKatalog erkunden")]),_vm._v(" "),_c('ul',{staticClass:"suggestion-list"},[_c('li',[_c('router-link',{staticClass:"button",attrs:{"to":{ name: 'sk-overview'}}},[_vm._v("Alles in einer Liste")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"button",attrs:{"to":{ name: 'sk-map'}}},[_vm._v("Alles auf einer Karte")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"button",attrs:{"to":{ name: 'sk-map', query: { tag: '3420 :: einkaufen + genießen' } }}},[_vm._v("Einkaufen + Genießen")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"button",attrs:{"to":{ name: 'sk-map', query: { tag: '3420 :: gesundheit + freizeit' } }}},[_vm._v("Gesundheit + Freizeit")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"button",attrs:{"to":{ name: 'sk-map', query: { tag: '3420 :: bildung + kultur' } }}},[_vm._v("Bildung + Kultur")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"button",attrs:{"to":{ name: 'sk-map', query: { tag: '3420 :: wohnen + arbeiten' } }}},[_vm._v("Wohnen + Arbeiten")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"button",attrs:{"to":{ name: 'sk-map', query: { tag: '3420 :: nachbarschaft' } }}},[_vm._v("Nachbarschaft")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"button",attrs:{"to":{ name: 'sk-map', query: { tag: '3420 :: mobilität' } }}},[_vm._v("Mobilität")])],1)])]),_vm._v(" "),_c('section',{staticClass:"something-missing"},[_c('p',[_vm._v("\n        Fehlt dein Unternehmen oder Geschäft? Hast du einen Verein oder bietest eine Dienstleistung an?\n        Du kannst schnell und einfach neue Einträge für die StadtKatalog vorschlagen,\n        oder Ergänzungen und Korrekturen für bestehende Einträge einreichen.\n      ")]),_vm._v(" "),_c('p',{staticClass:"suggest-stadtkatalog-entry"},[_c('a',{staticClass:"button",attrs:{"href":_vm.proposalUrl}},[_vm._v("\n          Eintrag vorschlagen\n        ")])])])]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 330:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 331:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAApCAQAAAACach9AAACMUlEQVR4Ae3ShY7jQBAE0Aoz/f9/HTMzhg1zrdKUrJbdx+Kd2nD8VNudfsL/Th///dyQN2TH6f3y/BGpC379rV+S+qqetBOxImNQXL8JCAr2V4iMQXHGNJxeCfZXhSRBcQMfvkOWUdtfzlLgAENmZDcmo2TVmt8OSM2eXxBp3DjHSMFutqS7SbmemzBiR+xpKCNUIRkdkkYxhAkyGoBvyQFEJEefwSmmvBfJuJ6aKqKWnAkvGZOaZXTUgFqYULWNSHUckZuR1HIIimUExutRxwzOLROIG4vKmCKQt364mIlhSyzAf1m9lHZHJZrlAOMMztRRiKimp/rpdJDc9Awry5xTZCte7FHtuS8wJgeYGrex28xNTd086Dik7vUMscQOa8y4DoGtCCSkAKlNwpgNtphjrC6MIHUkR6YWxxs6Sc5xqn222mmCRFzIt8lEdKx+ikCtg91qS2WpwVfBelJCiQJwvzixfI9cxZQWgiSJelKnwBElKYtDOb2MFbhmUigbReQBV0Cg4+qMXSxXSyGUn4UbF8l+7qdSGnTC0XLCmahIgUHLhLOhpVCtw4CzYXvLQWQbJNmxoCsOKAxSgBJno75avolkRw8iIAFcsdc02e9iyCd8tHwmeSSoKTowIgvscSGZUOA7PuCN5b2BX9mQM7S0wYhMNU74zgsPBj3HU7wguAfnxxjFQGBE6pwN+GjME9zHY7zGp8wVxMShYX9NXvEWD3HbwJf4giO4CFIQxXScH1/TM+04kkBiAAAAAElFTkSuQmCC"

/***/ }),

/***/ 334:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_whatwg_fetch__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_whatwg_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_whatwg_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(31);







__WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* default */]);

var API_URL = "https://app.stadtkatalog.org/opendata/v1";
var _STADTKATALOG_CONFIG = {"siteName":"StadtKatalog","geoFenceName":null,"mapZoom":12,"mapCenter":[48.208417,16.372472],"clusterOptions":{"maxClusterRadius":50}},
    geoFenceName = _STADTKATALOG_CONFIG.geoFenceName;


/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* default */].Store({
  state: {
    loading: false,
    query: "",
    querySize: 10,
    queryFrom: 0,
    hits: [],
    totalHits: -1,
    geoFenceName: geoFenceName,
    geoJson: {},
    geoJsonTagFilter: null,
    promotionDays: 7,
    promotionEntries: [],
    overview: {
      entries: [],
      size: 25,
      page: 0,
      total: 0
    }
  },
  getters: {
    standardParameters: function standardParameters(state) {
      return ["size=" + state.querySize, "from=" + state.queryFrom, "validAfter=" + new Date().toISOString()].join("&");
    },
    updateUrl: function updateUrl(state, getters) {
      return API_URL + "/search/fulltext?q=" + encodeURIComponent(state.query) + "&" + getters.standardParameters + (state.geoFenceName !== null ? "&geoFenceName=" + state.geoFenceName : "");
    },
    geoJsonUrl: function geoJsonUrl(state, getters) {
      return API_URL + "/export/geojson?size=1000" + (state.geoFenceName !== null ? "&geoFenceName=" + state.geoFenceName : "");
    },
    promotionsUrl: function promotionsUrl(state, getters) {
      return API_URL + "/search/promotions?size=10&" + "promotionStartAfter=" + encodeURIComponent(__WEBPACK_IMPORTED_MODULE_3_moment__().startOf("day").format()) + "&promotionStartBefore=" + encodeURIComponent(__WEBPACK_IMPORTED_MODULE_3_moment__().add(state.promotionDays, "days").endOf("day").format()) + (state.geoFenceName !== null ? "&geoFenceName=" + state.geoFenceName : "");
    },
    entryListUrl: function entryListUrl(state, getters) {
      return API_URL + "/export/json?sortField=name&sortOrder=asc&size=" + state.overview.size + "&from=" + state.overview.page * state.overview.size + (state.geoFenceName !== null ? "&geoFenceName=" + state.geoFenceName : "");
    },
    currentPage: function currentPage(state) {
      return Math.floor(state.queryFrom / state.querySize) + 1;
    },
    totalPages: function totalPages(state) {
      return Math.ceil(state.totalHits / state.querySize);
    },
    hasNextPage: function hasNextPage(state) {
      return state.queryFrom + state.querySize < state.totalHits;
    },
    hasPrevPage: function hasPrevPage(state) {
      return state.queryFrom > 0;
    },
    hasNextOverviewPage: function hasNextOverviewPage(state) {
      return state.overview.total > state.overview.size * state.overview.page + state.overview.size;
    },
    hasPrevOverviewPage: function hasPrevOverviewPage(state) {
      return state.overview.page > 0;
    }
  },
  actions: {
    updateHits: function updateHits(_ref) {
      var _this = this;

      var commit = _ref.commit;

      commit("setLoading", true);
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        fetch(_this.getters.updateUrl).then(function (response) {
          if (response.ok) {
            return response.json();
          }

          throw new Error("Network error.");
        }).then(function (json) {
          commit("setResultState", {
            totalHits: json.totalHits,
            hits: json.hits
          });
          commit("setLoading", false);
          resolve();
        }).catch(function (ex) {
          commit("setLoading", false);
          console.error(ex);
          commit("setResultState", {
            totalHits: -1,
            hits: []
          });
          reject(ex);
        });
      });
    },
    updateGeoJson: function updateGeoJson(_ref2) {
      var _this2 = this;

      var commit = _ref2.commit;

      commit("setLoading", true);
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        fetch(_this2.getters.geoJsonUrl).then(function (response) {
          commit("setLoading", false);
          return response.json();
        }).then(function (json) {
          if (_this2.state.geoJsonTagFilter !== null) {
            json.features = json.features.filter(function (feature) {
              return feature.properties.tags.indexOf(_this2.state.geoJsonTagFilter) >= 0;
            });
          }

          commit("setGeoJson", {
            object: json
          });
          resolve();
        }).catch(function (ex) {
          console.error(ex);
          commit("setGeoJson", {
            object: {}
          });
          reject();
        });
      });
    },
    updatePromotionEntries: function updatePromotionEntries(_ref3) {
      var _this3 = this;

      var commit = _ref3.commit;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        fetch(_this3.getters.promotionsUrl).then(function (response) {
          return response.json();
        }).then(function (json) {
          commit("setPromotionEntries", {
            entries: json.hits
          });
          resolve();
        }).catch(function (ex) {
          console.error(ex);
          commit("setPromotionEntries", {
            entries: []
          });
          reject();
        });
      });
    },
    updateOverview: function updateOverview(_ref4) {
      var _this4 = this;

      var commit = _ref4.commit;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        fetch(_this4.getters.entryListUrl).then(function (response) {
          commit("setOverviewTotal", {
            count: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default()(response.headers.get("Export-Total-Results"))
          });
          return response.json();
        }).then(function (json) {
          commit("setOverviewEntries", {
            entries: json
          });
          resolve();
        }).catch(function (ex) {
          console.error(ex);
          commit("setOverviewEntries", {
            entries: []
          });
          reject();
        });
      });
    },
    prevOverviewPage: function prevOverviewPage(_ref5) {
      var commit = _ref5.commit;

      if (this.getters.hasPrevOverviewPage) {
        commit("prevOverviewPage");
      }
    },
    nextOverviewPage: function nextOverviewPage(_ref6) {
      var commit = _ref6.commit;

      if (this.getters.hasNextOverviewPage) {
        commit("nextOverviewPage");
      }
    }
  },
  mutations: {
    resetQueryStates: function resetQueryStates(state) {
      state.loading = false;
      state.query = "";
      state.queryFrom = 0;
      state.totalHits = -1;
      state.hits = [];
    },
    setLoading: function setLoading(state, loading) {
      state.loading = loading === true;
    },
    setQuery: function setQuery(state, query) {
      state.query = query;
    },
    setResultState: function setResultState(state, _ref7) {
      var hits = _ref7.hits,
          totalHits = _ref7.totalHits;

      state.hits = hits;
      state.totalHits = totalHits;
    },
    setQueryFrom: function setQueryFrom(state, queryFrom) {
      state.queryFrom = queryFrom;
    },
    setGeoJsonTagFilter: function setGeoJsonTagFilter(state, filter) {
      state.geoJsonTagFilter = filter;
    },
    setGeoJson: function setGeoJson(state, _ref8) {
      var object = _ref8.object;

      state.geoJson = object;
    },
    setPromotionEntries: function setPromotionEntries(state, _ref9) {
      var entries = _ref9.entries;

      state.promotionEntries = entries;
    },
    setOverviewTotal: function setOverviewTotal(state, _ref10) {
      var count = _ref10.count;

      state.overview.total = count;
    },
    setOverviewEntries: function setOverviewEntries(state, _ref11) {
      var entries = _ref11.entries;

      state.overview.entries = entries;
    },
    nextOverviewPage: function nextOverviewPage(state) {
      state.overview.page++;
    },
    prevOverviewPage: function prevOverviewPage(state) {
      state.overview.page--;
    }
  }
}));

/***/ })

},[158]);


// WEBPACK FOOTER //
// static/js/app.b44a5e0a97adfc7854c2.js